/* eslint-disable */
import Api from '@/api/services/Api';

const route = '/asistencia'

export default {
    get: params => {
        let customRoute = `${route}?expand=empleado,justificacion`
        switch (params.asistenciaGroupBy) {
            case "2": customRoute = `empleado?fields=id,nombre,apellido_paterno,apellido_materno&expand=asistencia_totales`
                break;
            case "5": customRoute = `empleado?fields=id,nombre,apellido_paterno,apellido_materno&${params.customfilter}&expand=asistencia_totales` //totales de asistencia con filtros aplicados
                break;
            case "7": customRoute = `${params.customfilter}` //totales de asistencia con filtros aplicados
                break;
            case "3": customRoute = `${route}?${params.customfilter}&expand=empleado,justificacion` //asistencias de ayer
                break;
            case "4": customRoute = `${route}?${params.customfilter}&expand=empleado,justificacion` //asistencias de hoy
                break;
            case "8": customRoute = `${route}?${params.customfilter}&expand=empleado,justificacion` //asistencias ultimo mes
                break;
            case "9": customRoute = `${route}?${params.customfilter}&expand=empleado,justificacion` //asistencias 30 dias anteriores
                break;
            case "6": customRoute = `${route}?${params.customfilter}&expand=empleado,justificacion`
                break;
            default: break;
        }
        return Api().get(customRoute, { params, crossDomain: true })
    },
    getAll: () => Api().get(`${route}`, { crossDomain: true }),
    post: payload => Api().post(`${route}`, payload),
    put: payload => Api().put(`${route}/${payload.id}?expand=empleado,justificacion`, payload),
    loadAsistencia: params => Api().get(`${route}?empleado_id=${params.empleado_id}&${params.dateRangeFilter}`, { params }),
    getEmpleado: payload => Api().get(`empleado/${payload.empleado_id}?fields=id,nombre,apellido_paterno,apellido_materno`),
}
